<template>
  <div class="card" ref="section">
    <div class="card-header">
      <div class="section__header">
        <div class="section__header--left media">
          <i v-bind:class="getSectionIcon" aria-hidden="true"></i>
          <div class="media-body">
            <h5 class="card-title">{{section.title}}</h5><br/>
            <h6 v-if="section.subTitle" class="card-title text-muted">{{section.subTitle}}</h6>
          </div>
        </div>
        <div class="section__header--right">
          <i v-on:click="isOpen = !isOpen" v-if="isOpen" class="fa fa-chevron-up" aria-hidden="true"></i>
          <i v-on:click="isOpen = !isOpen" v-if="!isOpen" class="fa fa-chevron-down" aria-hidden="true"></i>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="card-body" v-show="isOpen" v-bind:class="{'section__body--after-intro' : section.introduction}">
        <div class="section__intro" v-if="section.introduction" v-bind:inner-html.prop="section.introduction | marked"></div>
        <FormAnswer v-for="answer in section.answers" v-bind:answer="answer"
                    v-bind:guestReference="guestReference"
                    v-bind:responseReference="responseReference"
                    v-bind:key="answer.reference"
                    v-bind:answerCache="answerCache"
                    v-bind:editable="editable"
                    v-bind:sectionVisible="isOpen"/>
        <button v-if="!last && editable" v-on:click="nextSection" type="button" class="btn btn-primary">Next</button>
      </div>
    </transition>
  </div>
</template>

<script>
import FormAnswer from './FormAnswer'

export default {
  name: 'FormSection',
  components: {
    FormAnswer
  },
  props: {
    section: Object,
    sectionNumber: Number,
    guestReference: String,
    responseReference: String,
    answerCache: Object,
    editable: Boolean
  },
  data: function () {
    return {
      last: false,
      first: false,
      isOpen: false
    }
  },
  computed: {
    isSectionGuest: function () {
      return (this.section.type && this.section.type.startsWith('personal-information'))
    },
    getSectionIcon: function () {
      switch (String(this.section.type)) {
        case 'stay-information':
          return 'fas fa-concierge-bell'
        case 'room-information':
          return 'fas fa-bed'
        case 'personal-information-adult':
          return 'fa fa-male'
        case 'personal-information-child':
          return 'fas fa-child'
        case 'terms-and-conditions':
          return 'fas fa-file-contract'
        case 'general':
        default:
          return 'fas fa-list'
      }
    }
  },
  methods: {
    nextSection: function () {
      const rect = this.$el.getBoundingClientRect()
      window.scrollTo(rect.x, window.pageYOffset + rect.top - 5)
      this.isOpen = false
      this.$root.$emit('section-complete', this.sectionNumber)
    },
    openSection: function (callback) {
      setTimeout(() => {
        this.isOpen = true
        if (callback !== undefined) {
          setTimeout(() => {
            callback()
          }, 250)
        }
      }, 250)
    },
    scrollToTopOfSection: function () {
      const rect = this.$el.getBoundingClientRect()
      window.scrollTo(rect.x, window.pageYOffset + rect.top - 5)
    },
    checkIfShouldOpen: function (previousSectionNumber) {
      if (this.sectionNumber === (previousSectionNumber + 1)) {
        this.openSection(this.scrollToTopOfSection)
      }
    }
  },
  mounted () {
    this.last = this.$parent.$children[this.$parent.$children.length - 1] === this
    this.first = this.$parent.$children[0] === this
    this.isOpen = this.first
    this.$root.$on('section-complete', this.checkIfShouldOpen)
  },
  beforeDestroy () {
    this.$root.$off('section-complete', this.checkIfShouldOpen)
  }
}
</script>

<style scoped>
    .card {
        margin: 10px 5px;
    }

    .card-header {
        border-bottom: none;
        background-color: #ffffff;
    }

    .card h5, .card h6 {
        margin-bottom: 0;
        display: inline-block;
    }

    .card ul {
        margin: 0;
        padding: 0;
    }

    .card li {
        padding: 0;
        list-style: none;
    }

    .card button {
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        display: block;
    }

    .section__intro {
      padding: 0 20px 20px 20px;
    }

    .section__header {
      display: flex;
      flex-direction: row;
    }

    .section__header--left {
       flex: 1;
     }

    .section__header--left i {
       margin-right: 10px;
     }

    .section__header--right {
      cursor: pointer;
    }

    .section__body--after-intro {
      padding-top: 0;
    }

    .card i  {
        font-size: 1.75rem;
    }

    .card .btn {
      font-weight: bold;
    }
    .card .fa-child {
        font-size: 1.2rem;
    }

    .fade-leave-active {
      transition: opacity 1.0s;
    }
    .fade-enter-active {
      transition: opacity 1.0s;
    }
    .fade-enter, .fade-leave-to {
      opacity: 0;
    }
</style>
